<template>
	<div class="SearchForPeople">
		<div v-if="!SearchForPeoplelist" class="SearchForPeople_container">
			<div class="SearchForPeople_list" v-for="item in list">
				<div class="SearchForPeople_list_top" @click="SeekDetails(item.trackid)">
					<div class="SearchForPeople_list_top_left">
						<img :src="item.trackimg" />
					</div>
					<div class="SearchForPeople_list_top_container">
						<div class="SearchForPeople_list_top_content_title"></div>
						<div class="SearchForPeople_list_top_content_text">{{item.trackdescribe}}</div>
					</div>
					<div class="SearchForPeople_list_top_right_three" v-if="item.status==0">
						审核中
					</div>
					<div class="SearchForPeople_list_top_right" v-if="item.status==1">
						找寻中
					</div>
					<div class="SearchForPeople_list_top_right_one" v-if="item.status==2">
						已找到
					</div>
					<div class="SearchForPeople_list_top_right_two" v-if="item.status==3">
						审核拒绝
					</div>
				</div>
				<div class="SearchForPeople_list_bottom">
					<div @click="SeekDetails(item.trackid)" class="SearchForPeople_list_bottom_left">提交时间：{{item.createtime}}</div>
					<div v-if="item.status==1" class="SearchForPeople_list_bottom_right" @click="modifyStatus(item.trackid)">已找到</div>
					<div v-if="item.status!=1" class="SearchForPeople_list_bottom_right" @click="deleteStatus(item.trackid)">删除</div>
				</div>
			</div>
		</div>
		<div v-else="" class="SearchForPeople_container_no">暂无寻人</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'SearchForPeople',
		inject: ['reload'],
		data() {
			return {
				baseUrl: "",
				SearchForPeoplelist: false,
				list: [],
				access_token: ""
			}
		},
		methods: {
			deleteStatus(trackid) {
				var that = this;
				wclient.view.showLoading();
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "GET",
					url: that.baseUrl + '?ugi=tracking&action=trackingEdit',
					dataType: "json",
					async: true,
					data: {
						access_token: that.access_token,
						trackid: trackid,
						status: '9'
					},
					success: function(data) {
						wclient.view.hideLoading();
						if(data.code == 'A00006') {
							that.reload()
						}
					}
				});
			},
			modifyStatus(trackid) {
				var that = this;
				wclient.view.showLoading();
				wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
				wclient.ajax({
					type: "GET",
					url: that.baseUrl + '?ugi=tracking&action=trackingEdit',
					dataType: "json",
					async: true,
					data: {
						access_token: that.access_token,
						trackid: trackid,
						status: '1'
					},
					success: function(data) {
						wclient.view.hideLoading();
						if(data.code == 'A00006') {
							that.reload()
						}
					}
				});
			},
			SeekDetails(trackid) {
				var that = this;
				sessionStorage.setItem('trackid', trackid)
				sessionStorage.setItem('Seek', 'myseek')
				that.$router.push({
					name: 'SeekDetails'
				})
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
			}
			that.baseUrl = baseUrl;
			that.access_token = localStorage.getItem('access_token')
			wclient.view.showLoading();
			wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
			wclient.ajax({
				type: "GET",
				url: that.baseUrl + '?ugi=tracking&action=usertrackingList',
				dataType: "json",
				async: true,
				data: {
					access_token: that.access_token
				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						if(data.list.length == 0) {
							that.SearchForPeoplelist = true;
						} else {
							that.list = data.list;
						}
					}
				}
			});
		}
	}
</script>

<style scoped>
	.SearchForPeople {
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	
	.SearchForPeople_container {
		width: 100%;
	}
	
	.SearchForPeople_container_no {
		width: 100%;
		font-size: 20px;
		text-align: center;
		line-height: 200px;
		font-weight: 600;
	}
	
	.SearchForPeople_list {
		width: 86%;
		float: left;
		background: url(../assets/fill_top.png) center center no-repeat;
		background-size: 100% 100%;
		margin: 10px 3% 0;
		padding: 4% 4% 3% 4%;
	}
	
	.SearchForPeople_list_top {
		width: 100%;
		height: 55px;
		display: flex;
		justify-content: space-between;
		padding-bottom: 28px;
	}
	
	.SearchForPeople_list_bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	
	.SearchForPeople_list_top_left {
		width: 55px;
		height: 55px;
		overflow: hidden;
	}
	
	.SearchForPeople_list_top_container {
		width: 58%;
	}
	
	.SearchForPeople_list_top_content_title {
		width: 100%;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-line-clamp: 1;
		overflow: hidden;
		color: black;
		font-size: 15px;
		font-weight: 600;
	}
	
	.SearchForPeople_list_top_content_text {
		width: 100%;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-box-pack: center;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-size: 12px;
		color: #A1A8AC;
	}
	
	.SearchForPeople_list_top_right {
		background: #D01511;
		color: white;
		font-size: 12px;
		padding: 4px 8px;
		height: 12px;
		line-height: 12px;
	}
	
	.SearchForPeople_list_top_right_one {
		background: #8AC349;
		color: white;
		font-size: 12px;
		padding: 4px 8px;
		height: 12px;
		line-height: 12px;
	}
	
	.SearchForPeople_list_top_right_two {
		background: #B1B1B1;
		color: white;
		font-size: 12px;
		padding: 4px 8px;
		height: 12px;
		line-height: 12px;
	}
	.SearchForPeople_list_top_right_three {
		color: white;
		font-size: 12px;
		padding: 4px 8px;
		height: 12px;
		line-height: 12px;
		background: #F39925;
	}
	.SearchForPeople_list_bottom {
		display: flex;
		align-items: center;
	}
	
	.SearchForPeople_list_bottom_left {
		font-size: 12px;
		color: #BBBBBB;
	}
	
	.SearchForPeople_list_bottom_right {
		font-size: 11px;
		color: #BBBBBB;
		border: 1px solid rgba(194, 194, 194, 1);
		border-radius: 31px;
		padding: 2px 10px;
	}
</style>


// WEBPACK FOOTER //
// src/components/SearchForPeople.vue